import { render, staticRenderFns } from "./UserCumulative.vue?vue&type=template&id=137beb34&scoped=true"
import script from "./UserCumulative.vue?vue&type=script&lang=js"
export * from "./UserCumulative.vue?vue&type=script&lang=js"
import style0 from "./UserCumulative.vue?vue&type=style&index=0&id=137beb34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137beb34",
  null
  
)

export default component.exports